module.exports = require("@react-pdf/renderer");